import flatpickr from "flatpickr";
import { Grid, IconButton, Tooltip } from "@mui/material";
import DateRangePicker from "@/shared/components/ui/CustomSearch/DateRangePicker";
import { useRef } from "react";
import Flatpickr from 'react-flatpickr';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import { gridSizeMdLg1 } from "@/shared";

export type CustomRangeCalendarProps = {
  text?: string;
  value?: string;
  label?: string;
  onChange?: (value: any) => void;
  onChangeRangeDate?: (range: Date[]) => void;
  cleanFilter?: () => void;
  custom_options?: Partial<flatpickr.Options.Options>;
  defaultValue?:Date[] | string[]
};

const CustomRangeDate = ({
  label,
  onChangeRangeDate,
  cleanFilter,
  custom_options,
  defaultValue
}: CustomRangeCalendarProps) => {
  const flatpickrRef = useRef<Flatpickr>(null);

  const handleDateChange = (range: Date[]) => {
    // Solo ejecutamos onChangeRangeDate cuando tenemos un rango completo (2 fechas)
    if (range.length === 2 && onChangeRangeDate) {
      onChangeRangeDate(range);
    }
  };

  return (
    <Grid item container spacing={1} alignItems={"center"} justifyContent={"flex-end"}>
      {onChangeRangeDate && (
        <DateRangePicker
          label={label || ""}
          flatpickrRef={flatpickrRef}
          onChange={handleDateChange}
          custom_options={custom_options}
          defaultValue={defaultValue}
        />
      )}
      <Grid item {...gridSizeMdLg1}>
        <Tooltip title="Limpiar">
          <IconButton
            onClick={() => {
              if (flatpickrRef.current) {
                flatpickrRef.current.flatpickr.clear();
              }
              cleanFilter && cleanFilter();
            }}
          >
            <FilterAltOffIcon color="primary" />
          </IconButton>
        </Tooltip>
      </Grid>

    </Grid>
   
  );
};

export default CustomRangeDate;